import { axiosInstance } from './Api';

export const fetchDistributorDashboard = async () => {
    const { data } = await axiosInstance.get('/distributor/dashboard');
    return data;
};

export const fetchDistributorManufacturers = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/manufacturers', { params });
    return data;
};

export const fetchDistributorManufacturerStats = async () => {
    const { data } = await axiosInstance.get('/distributor/manufacturers/stats');
    return data;
};

export const fetchDistributorManufacturerDetail = async (manufacturerId) => {
    const { data } = await axiosInstance.get(`/distributor/manufacturers/${manufacturerId}`);
    return data;
};

export const fetchDistributorRetailers = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/retailers', { params });
    return data;
};

export const fetchDistributorRetailerStats = async () => {
    const { data } = await axiosInstance.get('/distributor/retailers/stats');
    return data;
};

export const fetchDistributorRetailerDetail = async (retailerId) => {
    const { data } = await axiosInstance.get(`/distributor/retailers/${retailerId}`);
    return data;
};

export const fetchDistributorRetailersGraph = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/retailers/graph', { params });
    return data;
};

export const fetchDistributorVenues = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/venues', { params });
    return data;
};

export const fetchDistributorVenueDetail = async (venueId) => {
    const { data } = await axiosInstance.get(`/distributor/venues/${venueId}`);
    return data;
};

export const fetchDistributorTransactionStats = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/analytics/transactions/stats', { params });
    return data;
};

export const fetchDistributorTransactionDemographics = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/analytics/transactions/demographics', { params });
    return data;
};

export const fetchDistributorTransactionProgress = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/analytics/transactions/progress', { params });
    return data;
};

export const fetchDistributorSettings = async () => {
    const { data } = await axiosInstance.get('/distributor/settings');
    return data;
};

export const updateDistributorSettings = async (payload) => {
    const { data } = await axiosInstance.put('/distributor/settings', payload);
    return data;
};

export const regenerateDistributorApiToken = async () => {
    const { data } = await axiosInstance.post('/distributor/settings/api-token');
    return data;
};

export const fetchDistributorIntegrations = async () => {
    const { data } = await axiosInstance.get('/distributor/integrations');
    return data;
};

export const fetchDistributorIntegration = async (integrationId) => {
    const { data } = await axiosInstance.get(`/distributor/integrations/${integrationId}`);
    return data;
};

export const createDistributorIntegration = async (payload) => {
    const { data } = await axiosInstance.post('/distributor/integrations', payload);
    return data;
};

export const updateDistributorIntegration = async (integrationId, payload) => {
    const { data } = await axiosInstance.put(`/distributor/integrations/${integrationId}`, payload);
    return data;
};

export const deleteDistributorIntegration = async (integrationId) => {
    await axiosInstance.delete(`/distributor/integrations/${integrationId}`);
};

export const rotateDistributorIntegrationCredentials = async (integrationId) => {
    const { data } = await axiosInstance.post(`/distributor/integrations/${integrationId}/rotate-credentials`);
    return data;
};

export const pingDistributorIntegrationWebhook = async (integrationId) => {
    const { data } = await axiosInstance.post(`/distributor/integrations/${integrationId}/webhook-test`);
    return data;
};

export const fetchDistributorImports = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/imports', { params });
    return data;
};

export const createDistributorImport = async (payload) => {
    const { data } = await axiosInstance.post('/distributor/imports', payload);
    return data;
};

export const fetchDistributorExports = async (params = {}) => {
    const { data } = await axiosInstance.get('/distributor/exports', { params });
    return data;
};

export const createDistributorExport = async (payload) => {
    const { data } = await axiosInstance.post('/distributor/exports', payload);
    return data;
};
